import { useQuery } from "@tanstack/react-query";

import { getOrganizationTenants } from "api/tenants";
import { queryKeys } from "./queryKeys";

import { PaginationTable } from "js/components/types";

interface UseGetOrganizationTenantsOptions {
  pagination: PaginationTable;
  enabled?: boolean;
}

export const useGetOrganizationTenants = (
  options: UseGetOrganizationTenantsOptions,
) => {
  const { pagination, enabled = true } = options;

  return useQuery({
    queryKey: [...queryKeys.tenants.organization(), pagination],
    queryFn: () => getOrganizationTenants(pagination),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
